import { Component, ElementRef, inject, Input } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { LookupService } from '@core/services/lookup.service';
import { UserManagementService } from '@views/features/management/services/user-management.service';
import { ReportService } from '../services/report.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDistrict } from '@core/interfaces/ilookup';
import { IUser } from '@core/interfaces/iuser';
import { Role } from '@core/enums/roles';
import { take, tap } from 'rxjs';
import { IReportRequest } from '../interfaces/ireport-request';
import { ISearchCompletionResponse } from '../interfaces/ireport-response';
import { ReportHeaders } from '../enums/report-headers';
import { SchoolYear } from '../enums/school-year';
import { IColumnSort } from '@core/interfaces/itable';

@Component({
  selector: 'prism-report-completion-view',
  templateUrl: './report-completion-view.component.html',
  styleUrl: './report-completion-view.component.scss'
})
export class ReportCompletionViewComponent {
  userManagementService = inject(UserManagementService);
      private lookupService= inject(LookupService);
      private authService = inject(AuthService);
      private reportService = inject(ReportService);
      private fb = inject(FormBuilder);
      columns: string [] = ['districtName', 'schoolName', 'completionCount', 'incompleteCount'];
      data:  ISearchCompletionResponse[] = [];
      colHeaders = ReportHeaders;
      userForm!: FormGroup;
      organizationOptions: IDistrict[] = [];
      pageIndex = 1;
      pageSize = 10;
      totalData = 0;
      reportType = '';
      pageTitle = 'Completions';
      searchForm!: FormGroup;
      user: IUser = this.authService.getCurrentUser();
      role = Role;
      @Input() schoolYearId: number = SchoolYear.SY2026;;
  
      get organization() {
        return this.searchForm.get('organization');
      }
  
    ngOnInit(): void {
      this.initializeForm();
      this.searchReport();
      this.getOrganizations();
      this.listenOrganization();
    }
  
    initializeForm(): void {
      this.searchForm = this.fb.group({
        organization: [null],
        sortDirection: ['asc'],
        sortColumn: [null]
      });
    }
  
    getOrganizations(): void {
      this.lookupService.getOrganizations().pipe(
        take(1),
        tap((res: IDistrict[]) => this.organizationOptions = res)
      ).subscribe();
    }

    listenOrganization(): void {
      this.organization?.valueChanges.pipe(
        tap(() => {
          this.searchReport();
        })
      ).subscribe();
    }
  
    handlePageIndexChange(pageIndex: number): void {
      this.pageIndex = pageIndex;
      this.searchReport();
    }
  
    handlePageSizeChange(pageSize: number): void {
      this.pageSize = pageSize;
      this.searchReport();
    }
  
    searchReport(event?: any): void {
      const payload: IReportRequest = {
        organization: this.organization?.value,
        schoolYearId: this.schoolYearId,
        pageIndex: this.pageIndex,
        ItemsPerPage: this.pageSize,
        sortDirection: this.searchForm.get('sortDirection')?.value,
        sortColumn: this.searchForm.get('sortColumn')?.value
      }
      this.districtCompletions(payload);
    }

    districtCompletions(payload: IReportRequest): void {
      this.reportService.searchDistrictCompletionReport(payload).pipe(
        take(1),
        tap((res: ISearchCompletionResponse) => {
          this.data = res.items.map((item: any) => {
            return {
              ...item
            }
          });
          this.pageIndex = res.pageIndex;
          this.totalData = res.totalData;
        })
      ).subscribe();
    }

    handleColumnDirectionChange(columnSort: IColumnSort): void {
    this.searchForm.patchValue({
      sortDirection: columnSort.direction,
      sortColumn: columnSort.column
    });
    this.searchReport();
  }
  
    downloadReport() {
      const payload: IReportRequest = {
        ...this.searchForm.value,
        schoolYearId: this.schoolYearId,
        pageIndex: this.pageIndex,
        ItemsPerPage: this.pageSize
      }

      this.reportService.downloadDistrictCompletionReport(payload).pipe(take(1)).subscribe((res:any) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(res.body);
        a.setAttribute('download', 'prism_completion_report.xlsx');
        a.click();
      });
    }
}
